<template>
  <nav class="site-nav">
    <div class="nav-inner">
      <!-- مجموعة الأيقونات -->
      <div class="nav-icons">
        <button class="nav-logo" @click="$router.push('/')" aria-label="الصفحة الرئيسية">
          🏠
        </button>
        <button class="nav-refresh" @click="refreshApp" aria-label="تحديث">
          <i class="fas fa-rotate-right"></i>
        </button>
      </div>

      <!-- عنوان التطبيق مع تأثير توهج ذهبي -->
      <h1 class="nav-title">MQBanK+</h1>

      <!-- إضاءة خلفية متحركة (تأثير إضافي) -->
      <div class="nav-glow"></div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  methods: {
    refreshApp() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(regs => {
          regs.forEach(reg => reg.unregister());
        });
      }
      window.location.reload(true);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@600;800;900&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css');

/* ============================================================
   أساسيات الشريط – تصميم زجاجي (Glassmorphism) مع تدرج داكن
   ============================================================ */
.site-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4.2rem; /* أطول قليلاً لإبراز الفخامة */

  /* خلفية متدرجة عميقة مع تأثير زجاجي */
  background: linear-gradient(145deg, rgba(15, 23, 42, 0.85), rgba(30, 27, 75, 0.90));
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);

  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0 0 24px 24px; /* حواف ناعمة في الأسفل */
  margin: 0 12px; /* مسافة جانبية لتبدو وكأنها تطفو */

  display: flex;
  align-items: center;
  z-index: 1000;

  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 0 0 1px rgba(255, 215, 0, 0.05); /* إطار ذهبي خفيف */

  transition: all 0.3s ease;
}

/* توهج خلفي متحرك (يضاف عبر عنصر إضافي) */
.site-nav::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 30% 50%, rgba(255, 215, 0, 0.08), transparent 70%);
  animation: glowPulse 6s ease-in-out infinite alternate;
  pointer-events: none;
  z-index: -1;
}

@keyframes glowPulse {
  0% { opacity: 0.4; transform: scale(1) rotate(0deg); }
  100% { opacity: 1; transform: scale(1.2) rotate(5deg); }
}

/* الحاوية الداخلية */
.nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
}

/* ============================================================
   مجموعة الأيقونات – أنيقة ومتناسقة
   ============================================================ */
.nav-icons {
  position: absolute;
  left: 1.2rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

/* زر الصفحة الرئيسية – بتدرج ذهبي لامع */
.nav-logo {
  background: linear-gradient(145deg, #f6e6b0, #d4af37 40%, #b8962e);
  border: none;
  border-radius: 50%;
  color: #1a1a2e;
  font-size: 1.3rem;
  cursor: pointer;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.4);
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
}
.nav-logo::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffd700, #b8860b, #ffd700);
  background-size: 300% 300%;
  z-index: -1;
  animation: shimmerBorder 4s ease-in-out infinite;
}
@keyframes shimmerBorder {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
.nav-logo:hover {
  transform: scale(1.15) rotate(-6deg);
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.7);
}

/* زر التحديث – بتدرج أزرق نيوني */
.nav-refresh {
  background: linear-gradient(145deg, #4f8cff, #1e4fd9);
  border: none;
  border-radius: 50%;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(30, 79, 217, 0.5);
  transition: all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
}
.nav-refresh:hover {
  transform: scale(1.15) rotate(90deg);
  box-shadow: 0 8px 30px rgba(30, 79, 217, 0.8);
}
.nav-refresh:active {
  transform: scale(0.9) rotate(180deg);
}

/* ============================================================
   العنوان – بتدرج ذهبي ونص مضيء مع أنيميشن
   ============================================================ */
.nav-title {
  font-size: 1.8rem;
  font-weight: 900;
  font-family: 'Cairo', sans-serif;
  margin: 0;
  letter-spacing: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  /* تدرج لوني ذهبي-أبيض مع ظل ناعم */
  background: linear-gradient(135deg, #f9f3d9, #f5d77b, #d9b650, #f9f3d9);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: goldShimmer 5s ease-in-out infinite alternate;

  text-shadow: none; /* نلغي الظل العادي لأننا نستخدم التدرج */
  filter: drop-shadow(0 0 12px rgba(255, 215, 0, 0.3));
  transition: filter 0.3s ease;
}
.nav-title:hover {
  filter: drop-shadow(0 0 25px rgba(255, 215, 0, 0.7));
}

@keyframes goldShimmer {
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
}

/* خط سفلي متحرك تحت العنوان */
.nav-title::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #f5d77b, #d9b650, #f5d77b, transparent);
  border-radius: 4px;
  animation: underlineSlide 3s ease-in-out infinite alternate;
  opacity: 0.7;
}
.nav-title {
  position: relative; /* لكي يعمل الـ after بشكل صحيح */
}

@keyframes underlineSlide {
  0% { width: 20%; opacity: 0.3; }
  100% { width: 80%; opacity: 1; }
}

/* ============================================================
   عنصر التوهج الإضافي (خلفية ضوئية متحركة)
   ============================================================ */
.nav-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255, 215, 0, 0.06), transparent 70%);
  pointer-events: none;
  z-index: -1;
  animation: glowFloat 8s ease-in-out infinite alternate;
}
@keyframes glowFloat {
  0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
  100% { transform: translate(-50%, -50%) scale(1.4); opacity: 1; }
}

/* ============================================================
   تحسينات إضافية للاستجابة والشاشات الصغيرة
   ============================================================ */
@media (max-width: 600px) {
  .site-nav {
    height: 3.8rem;
    border-radius: 0 0 16px 16px;
    margin: 0 6px;
  }
  .nav-title {
    font-size: 1.4rem;
  }
  .nav-logo, .nav-refresh {
    width: 2.4rem;
    height: 2.4rem;
    font-size: 1rem;
  }
  .nav-icons {
    gap: 0.5rem;
    left: 0.8rem;
  }
}

/* إزالة الـ outline الافتراضي للأزرار */
button:focus-visible {
  outline: 2px solid #f5d77b;
  outline-offset: 4px;
}
</style>